import { useField } from "formik";
import FormField from "layouts/pages/account/components/FormField";

interface EventoFormFieldProps {
  name: string;
  bindFormik?: boolean;
  [key: string]: any;
}

export default function EventoFormField({
  name,
  bindFormik = true,
  onBlur,
  onChange,
  value,
  helperText,
  ...rest
}: EventoFormFieldProps) {
  const [field, meta] = useField(name);
  const showError = Boolean(meta.touched && meta.error);

  return (
    <FormField
      {...rest}
      name={name}
      {...(bindFormik
        ? {
            value: value ?? field.value ?? "",
            onChange: onChange ?? field.onChange,
            onBlur: onBlur ?? field.onBlur,
          }
        : {
            ...(value !== undefined ? { value } : {}),
            ...(onChange ? { onChange } : {}),
            ...(onBlur ? { onBlur } : {}),
          })}
      error={showError}
      helperText={showError ? String(meta.error) : helperText}
    />
  );
}
